import { Component, input } from '@angular/core';

@Component({
  selector: 'app-ui-spinner',
  templateUrl: './ui-spinner.component.html',
  styleUrl: './ui-spinner.component.scss',
})
export class UiSpinnerComponent {
  size = input<number>(24);
}


